export class ErroFlagsmith extends Error {
  constructor(mensagem: string) {
    super(mensagem)
    this.name = 'ErroFlagsmith'
  }
}
